var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTool({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2501 5.24994C12.0974 5.40572 12.0119 5.61515 12.0119 5.83328C12.0119 6.0514 12.0974 6.26083 12.2501 6.41661L13.5835 7.74994C13.7392 7.90263 13.9487 7.98816 14.1668 7.98816C14.3849 7.98816 14.5943 7.90263 14.7501 7.74994L17.8918 4.60828C18.3108 5.53427 18.4377 6.56597 18.2555 7.5659C18.0733 8.56582 17.5907 9.48648 16.872 10.2052C16.1533 10.9239 15.2327 11.4065 14.2327 11.5887C13.2328 11.7708 12.2011 11.644 11.2751 11.2249L5.51679 16.9833C5.18527 17.3148 4.73563 17.501 4.26679 17.501C3.79795 17.501 3.34831 17.3148 3.01679 16.9833C2.68527 16.6518 2.49902 16.2021 2.49902 15.7333C2.49902 15.2644 2.68527 14.8148 3.01679 14.4833L8.77512 8.72494C8.35609 7.79895 8.22922 6.76725 8.41141 5.76732C8.5936 4.7674 9.0762 3.84674 9.79489 3.12804C10.5136 2.40935 11.4342 1.92675 12.4342 1.74456C13.4341 1.56237 14.4658 1.68925 15.3918 2.10828L12.2585 5.24161L12.2501 5.24994Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.02fc5725c7c658df3b2296f310602d93.svg";
export { ForwardRef as ReactComponent };